module.exports = __webpack_public_path__ + "img/no-assessment.b1beccd3.svg";